window.TD_PROMO = {
    "generated_at": "2026-11-05T10:00:05-05:00",
    "promotions": [
        {
            "code": "K6GD3X2",
            "name": "",
            "description": "6% OFF SALE",
            "type": "percent",
            "value": 6,
            "min_amount": 0,
            "starts_at": "2026-11-05T08:00:00-05:00",
            "ends_at": "2026-11-09T08:00:00-05:00"
        }
    ]
};
